import { find } from 'fxjs/es';
import { NewMakerSGuide } from '../../../S/module/NewMakerSGuide.js';

export const findBp = (base_product_id) => {
  return find((c) => {
    return base_product_id == c.base_product_id;
  }, NewMakerSGuide.GUIDE_DATA.confirm);
};
